import { Box, type SelectChangeEvent } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import { BaseDropdown } from 'ui-kit'

export type SelectOption = {
  value: string
  title?: string
}

type SelectInputProps = {
  id: string
  name?: string
  label: string
  required?: boolean
  value: string
  onChange: (event: SelectChangeEvent) => void
  error?: string
  options: SelectOption[]
  sx?: SxProps<Theme>
}

/** Thin adapter over ui-kit BaseDropdown for devices Salesforce forms. */
export function SelectInput({
  id,
  name,
  label,
  required = false,
  value,
  onChange,
  error,
  options,
  sx,
}: SelectInputProps) {
  return (
    <Box sx={{ mb: 2, ...sx }}>
      <BaseDropdown
        id={id}
        label={label}
        required={required}
        selectedValue={value}
        onSelection={selected => {
          onChange({
            target: { name: name ?? id, value: String(selected) },
          } as SelectChangeEvent)
        }}
        error={error}
        options={options.map(option => ({
          label: option.title ?? option.value,
          value: option.value,
        }))}
      />
    </Box>
  )
}
